import * as types from './actionTypes';  
import createUnderwriterApi from '../api/createUnderwriterApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doCreateUnderwriter(request) {

  return {
    type: types.DO_CREATE_UNDERWRITER, 
    request
  };
}

export function doCreateUnderwriterRes(data) {  
  return {
    type: types.DO_CREATE_UNDERWRITER_RES, 
    data
  };
}

export function createUnderwriter(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      createUnderwriterApi.doCreateUnderwriter(request).then(data => {
        dispatch(doCreateUnderwriterRes(data));
        dispatch(doCreateUnderwriterRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}